// extracted by mini-css-extract-plugin
export default {"top":"CustomInput_top__PjLg7"};